import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import toastr from 'toastr';
import Loader from '../utils/loader'

class PostReachModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            done: false
        };

        toastr.options = {
            closeButton: true,
            positionClass: "toast-bottom-full-width",
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "8000",
            extendedTimeOut: "1000",
        };
    }

    castToArray = (page) => {
        return Object.keys(page).map(function (key) {
            return [Number(key), page[key]];
        });
    };

    goToCampaignPerformance = () => {
        localStorage.removeItem('selected_main_type')

        this.props.onClickAway()
        this.props.history.push('/my-campaigns/fb-messenger')
    }

    goToCampaigns = () => {
        this.props.onClickAway()
        this.props.history.push('/new')
    }

    goToPaymentMethods = () => {
        this.props.onClickAway()
        this.props.history.push('/billing/payment-methods')
    }

    render() {

        let {
            visible_modal,
            onClickAway,
            post_reach_subscribers_count,
            postStats,
            count_push_subscrib,
            count_fb_subscrib,
            count_total_subscrib_sent
        } = this.props;

        return (
            <div id="postReachModal" className="modal" style={visible_modal ? {display: "block"} : {display: "none"}}>
                <div className="modal-content text-center" style={{maxWidth: "600px"}}>
                     <span id='close'
                           style={{
                               float: "right",
                               display: "inline-block",
                               padding: "2px 5px",
                               fontSize: "30px",
                               cursor: "pointer"
                           }}
                           onClick={onClickAway}>×
                        </span>


                    <div className="section section-content text-center post-reach">
                        {/*{console.log('modal error: ', this.props.fbError)}*/}
                        {this.props.fbError === '' ?
                            <React.Fragment>
                                <p className=" modal-title text-center m-m-b" style={{fontSize: "30px"}}>
                                    Sending attempted to:
                                </p>

                                {
                                    post_reach_subscribers_count > 0 ?
                                        <React.Fragment>
                                            <div className="section-content text-center">
                                                <p className="letter text-bold">
                                                    {post_reach_subscribers_count}
                                                    <span>{post_reach_subscribers_count === 1 ? 'Subscriber' : 'Subscribers'}</span>
                                                </p>
                                            </div>
                                            <div className="row reach-modal-performance-msg">
                                                Please visit <Link onClick={this.props.onClickAway} to='/my-campaigns'>campaign
                                                performance</Link> page for detailed
                                                analytics of this campaign.
                                            </div>
                                        </React.Fragment>
                                        :
                                        <div className="section-content text-center no-subscribers-reach m-lg-t">
                                            There are no subscribers <br></br> matching this criteria!
                                        </div>
                                }

                                <div className="m-lg-t flex-direction-row justify-content-space">
                                    <button className='btn-white'
                                            onClick={this.goToCampaignPerformance}>
                                        Go to My Campaigns
                                    </button>
                                    <button className='btn-action'
                                            onClick={this.goToCampaigns}>
                                        Start a new campaign
                                    </button>
                                </div>
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <h2 className='text-center'>Your payment method is missing!</h2>
                                <div id='reach-modal-payment-missing-buttons' className="m-lg-t flex-direction-row justify-content-space flex-wrap">
                                    <button className='btn-white'
                                            onClick={this.goToCampaignPerformance}>
                                        Go to My Campaigns
                                    </button>
                                    <button className='btn-action'
                                            onClick={this.goToPaymentMethods}>
                                        Update payment method
                                    </button>
                                </div>
                            </React.Fragment>
                        }


                        {/*<div className="m-lg-t flex-direction-row justify-content-space">*/}
                        {/*    <button className='btn-white'*/}
                        {/*            onClick={this.goToCampaignPerformance}>*/}
                        {/*        Go to My Campaigns*/}
                        {/*    </button>*/}
                        {/*    <button className='btn-action'*/}
                        {/*            onClick={this.goToCampaigns}>*/}
                        {/*        Start a new campaign*/}
                        {/*    </button>*/}
                        {/*</div>*/}

                    </div>

                </div>
            </div>
        )
    }
}

export default PostReachModal;
/*
<div className="col-md-12" style={{display: "block", color: "#ec6666", paddingTop: "50px"}}>
STATIC DATA FOR SUBSCRIBERS FOR CHANNELS! <br/> SENT DATA SPLITS, NOT YET IMPLEMENTED IN API &amp; RESPONSE. ONLY TOTAL SUBSCRIBERS COUNT.
</div>
*/